<template>
  <v-container>
    <v-layout column class="text-center" md12>
        
      <v-flex class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Cotiza ahora
        </h1>
      </v-flex>

      <v-flex
        class="mb-4"
        cols="12"
        row
      >
        <v-flex justify="center">
          <v-btn style="background-color: #9D4593; color: white; height: 100px; width:300px; font-size: 25px;" :to="'cotizador-mudanza'">Mudanza</v-btn>
        </v-flex>
      </v-flex>

      <v-flex
        class="mb-5"
        cols="12"
        row
      >
        <v-flex justify="center">
          <v-btn style="background-color: #9D4593; color: white; height: 100px; width:300px; font-size: 15px;" :to="'Express'">Flete (5 artículos. max)</v-btn>
        </v-flex>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'MainForm',

    data () {
      return {

      }
    },
    methods: {
      goTo(service) {
        console.log(service)
        const url = 'https://www.duoapp.cl/' + service + '?demo=1'
        const windowOpen = window.open(url)
        windowOpen
      }
    }
  }
</script>